<template>
<v-expansion-panels>
    <v-expansion-panel>
        <v-expansion-panel-header>
            <div class="detail font-weight-bold pa-0 ma-0">Social</div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-row no-gutters align="center" class="pt-2 im-search">
                <v-col cols="12" md="6">
                    <v-row no-gutters>
                        <img src="../../../assets/facebook.svg" height="30px" width="30px" class="ma-1">
                        <v-text-field class=" py-0 px-2 ma-0" placeholder="Facebook" v-model="item.social.facebook"></v-text-field>
                    </v-row>
                </v-col>
                <v-col cols="12" md="6">
                    <v-row no-gutters>
                        <img src="../../../assets/instagram.svg" height="30px" width="30px" class="ma-1">
                        <v-text-field class="py-0 px-2 ma-0" placeholder="Instagram" v-model="item.social.instagram"></v-text-field>
                    </v-row>
                </v-col>
                <v-col cols="12" md="6">
                    <v-row no-gutters>
                        <img src="../../../assets/twitter.svg" height="30px" width="30px" class="ma-1">
                        <v-text-field class="py-0 px-2 ma-0" placeholder="Twitter" v-model="item.social.twitter"></v-text-field>
                    </v-row>
                </v-col>
                <v-col cols="12" md="6">
                    <v-row no-gutters>
                        <img src="../../../assets/linkedin.svg" height="30px" width="30px" class="ma-1">
                        <v-text-field class="py-0 px-2 ma-0" placeholder="Linkedin" v-model="item.social.linkedin"></v-text-field>
                    </v-row>
                </v-col>
                <v-col cols="12" md="6">
                    <v-row no-gutters>
                        <img src="../../../assets/youtube.svg" height="30px" width="30px" class="ma-1">
                        <v-text-field class="py-0 px-2 ma-0" placeholder="Youtube" v-model="item.social.youtube"></v-text-field>
                    </v-row>
                </v-col>
                <v-col cols="12" md="6">
                    <v-row no-gutters>
                        <img src="../../../assets/google_plus.svg" height="30px" width="30px" class="ma-1">
                        <v-text-field class="py-0 px-2 ma-0" placeholder="Google plus" v-model="item.social.google_plus"></v-text-field>
                    </v-row>
                </v-col>
                <v-col cols="12" md="6">
                    <v-row no-gutters>
                        <img src="../../../assets/tumblr.svg" height="30px" width="30px" class="ma-1">
                        <v-text-field class="py-0 px-2 ma-0" placeholder="Tumblr" v-model="item.social.tumblr"></v-text-field>
                    </v-row>
                </v-col>
                <v-col cols="12" md="6">
                    <v-row no-gutters>
                        <img :src="pinterest" height="30px" width="30px" class="ma-1">
                        <v-text-field class="py-0 px-2 ma-0" placeholder="Pinterest" v-model="item.social.pinterest"></v-text-field>
                    </v-row>
                </v-col>
            </v-row>

        </v-expansion-panel-content>
    </v-expansion-panel>
</v-expansion-panels>
</template>

<script>
import {
    mapActions
} from 'vuex';
import defaults from "../../utils/PropDefaults.js";
import pinterest from "@/assets/pinterest.svg"

export default {

    props: {
        item: {
            type: Object,
            default: defaults.user_item
        },
    },

    components: {},
    data() {
        return {
            //props
            pinterest: pinterest,
        };
    },

    computed: {},

    watch: {},

    methods: {

        ...mapActions('alert', ['success', 'error']),

    }
};
</script>
